<div
  class="fixed inset-0 z-10000 bg-(--brand-primary) bg-cover bg-center bg-no-repeat p-6"
  [style.background-image]="'url(' + (bgImage ?? '/assets/images/status-screen-bg.png') + ')'"
>
  <!-- Scroll container -->
  <div class="w-full h-full overflow-y-auto no-scrollbar">
    
    <!-- Centering wrapper -->
    <div class="min-h-full flex items-center justify-center">
      
      <!-- Content -->
      <div
        class="w-full lg:w-[90%] xl:w-[80%] 2xl:w-[60%]
               mx-auto rounded-4xl text-center my-8 flex flex-col"
      >
        <ng-content></ng-content>
      </div>

    </div>
  </div>
</div>
